import React from 'react';

import { Checkbox, FormControlLabel } from '@mui/material';

import './styles.scoped.css';

const CheckboxRow = ({
  label,
  checked,
  onChange,
  disabled = false,
  error = false,
  errorMessage = '',
  className = '',
  style = {},
  ...rest
}) => (
  <>
    <FormControlLabel
      className={className}
      style={style}
      disabled={disabled}
      labelPlacement="start"
      label={label}
      sx={{
        display: 'flex',
        ml: 0,
        mr: 0,
        width: '100%',
        maxWidth: 380,
        marginBottom: '8px',
        justifyContent: 'space-between',
        '& .MuiFormControlLabel-label': { fontFamily: 'Arial, sans-serif', fontSize: 14, color: '#25282a' },
      }}
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          aria-invalid={!!error || undefined}
          sx={{ color: 'var(--primary)', '&.Mui-checked': { color: 'var(--primary)' }, padding: 0 }}
          {...rest}
        />
      }
    />
    {/* Inline error, directly under the checkbox — matches the Form* fields'
        error/errorMessage pattern. Renders nothing when no error is passed, so
        existing usages are unaffected. */}
    {error && errorMessage && <span className="error-message">{errorMessage}</span>}
  </>
);

export default CheckboxRow;
